// PurchaseList.jsx
import PropTypes from "prop-types";
import React from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

const PoList = ({
  purchaseDetails,
  selectedItemIndex,
  handlePurchaseCode,
  handlePoDisplay,
  getBackgroundColor,
  show,
}) => {
  return (
    <List sx={{ display: { xs: show ? "block" : "none", md: "block" } }}>
      {purchaseDetails?.map((poValue, index) => (
        <ListItem key={poValue?.PO} disablePadding>
          <ListItemButton
            sx={{
              display: "flex",
              justifyContent: index === selectedItemIndex ? "end" : "start",
              backgroundColor: getBackgroundColor(index, selectedItemIndex),
              borderRadius: "5px",
              color: index === selectedItemIndex ? "white" : "black",
              marginTop: "3px",
              // "&:hover": {
              //   backgroundColor: "steelblue",
              //   color: "white",
              // },
              "&:hover": {
                backgroundImage: "url(/assets/images/WaveImages.jpeg)",
                color: "white",
              },
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundImage:
                index === selectedItemIndex
                  ? "url(/assets/images/WaveImages.jpeg)"
                  : "url(/assets/images/backgroundWater.jpg)",
            }}
            onClick={() => {
              handlePurchaseCode(poValue?.PO, index);
            }}
          >
            <ListItemText primary={poValue?.PO} />
          </ListItemButton>
        </ListItem>
      ))}
      {(purchaseDetails?.length <= 0 ||
        purchaseDetails?.length === undefined) && (
        <Typography>No data available</Typography>
      )}
    </List>
  );
};

PoList.propTypes = {
  getBackgroundColor: PropTypes.func,
  handlePoDisplay: PropTypes.any,
  handlePurchaseCode: PropTypes.func,
  purchaseDetails: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }),
  selectedItemIndex: PropTypes.any,
  show: PropTypes.any,
};

export default PoList;
